export default "__VITE_ASSET__CfRvR04g__"